/*LOADING*/
.loading {
	display: flex;
	align-items: center;
	justify-content: center;
	height: 100%;
}

.loader {
	position: relative;
	width: 48px;
	height: 48px;
	background: var(--app-accent-color);
	transform: perspective(200px) rotateX(65deg) rotate(45deg);
	color: #fff;
	/*animation: layers1 1s linear infinite alternate;*/
}

.loader:after {
	content: '';
	position: absolute;
	inset: 0;
	background: rgba(0, 0, 0, 0.5);
	animation: layerTr 0.8s linear infinite alternate;
}

@keyframes layers1 {
	0% {
		box-shadow: 0px 0px 0 0px var(--app-accent-color);
	}
	90%,
	100% {
		box-shadow: 20px 20px 0 -4px var(--app-accent-color);
	}
}
@keyframes layerTr {
	0% {
		transform: translate(0, 0) scale(1);
	}
	100% {
		transform: translate(-25px, -25px) scale(1);
	}
}
